import { ErrorHandler, inject, Service } from '@angular/core';
import { MbmError } from './mbm-error';
import { ErrorLogService } from './error-log.service';
import { ErrorMessageService } from './error-message.service';

@Service()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly errorLog = inject(ErrorLogService);
  private readonly errorMessage = inject(ErrorMessageService);

  handleError(error: unknown): void {
    const mbmError = error as MbmError;
    const isOriginalUnhandled = !mbmError.originalError || !(mbmError.originalError as MbmError).handled;
    const isUnhandled = isOriginalUnhandled && !mbmError.handled;

    const isOpaqueCrossOriginError = this.isOpaqueCrossOriginError(error);

    if (isUnhandled && !isOpaqueCrossOriginError) {
      if (mbmError.statusCode === 403) {
        this.errorMessage.showForbiddenError();
      } else {
        this.errorMessage.showGlobalError();
      }
      console.error('[GlobalErrorHandler] Unhandled error:', error);
    }

    if (isUnhandled || mbmError.logError === true) {
      void this.errorLog.logErrorAsync(error);
    }
  }

  private isOpaqueCrossOriginError(error: unknown): boolean {
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
    return message.includes('Script error') || message.includes('An ErrorEvent with no error occurred');
  }
}
